import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reset",
  "use": "icon-reset-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 14 14\" id=\"icon-reset\"><path fill=\"#595959\" d=\"M12.362.72a.533.533 0 1 0-1.067 0v1.357A6.533 6.533 0 1 0 13.533 7a.533.533 0 1 0-1.066 0 5.467 5.467 0 1 1-1.723-3.983H9.001a.533.533 0 0 0 0 1.067h2.494a.867.867 0 0 0 .867-.867z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol